function getDocumentOrigin() {
    if (typeof window === 'undefined')
        return '';
    return window.location.origin;
}
function normalizeOriginOverride(origin) {
    return origin?.trim() || undefined;
}
function getPublicWebOrigin() {
    return (normalizeOriginOverride(typeof window === 'undefined' ? undefined : window.__PPLX_PUBLIC_WEB_ORIGIN__) ??
        normalizeOriginOverride(import.meta.env.VITE_PPLX_PUBLIC_WEB_ORIGIN) ??
        getDocumentOrigin());
}
export function getWindowOrigin({ intent }) {
    switch (intent) {
        case 'document':
            return getDocumentOrigin();
        case 'public-web':
            return getPublicWebOrigin();
    }
}
export function toPublicWebUrl(pathOrUrl) {
    const href = pathOrUrl.toString();
    const publicWebOrigin = getWindowOrigin({ intent: 'public-web' });
    if (!publicWebOrigin)
        return href;
    return new URL(href, publicWebOrigin).toString();
}
// Login-return targets need the whole address, not just the path: deep links
// select content through the query (`?item=`) and fragment (`#KA:`), so dropping
// either sends the visitor back to a default view instead of what they opened.
export function toPublicWebUrlForCurrentLocation() {
    if (typeof window === 'undefined')
        return undefined;
    const { pathname, search, hash } = window.location;
    return toPublicWebUrl(`${pathname}${search}${hash}`);
}
//# sourceMappingURL=location.js.map